import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../types';
import MainMenu from './MainMenu';
import { openMessageBox, openSettingsPopup } from '../actions';

function mapStateToProps(state: ApplicationState) {
  return ({
    ...state.main,
    ...state.login,
  });
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    openMessageBox,
    openSettingsPopup,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
